import {
  TaskFileModel,
  TaskImportFileModel,
  UserModel,
  WeeekTaskModel,
} from '@/components/task-forms/models';
import { TaskParentModel } from './TaskParentModel';
import { getDefaultDedlineDate } from '../utils';
import UserTaskItem from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/UserTaskItem';

/**
 * * Модель данных формы задачи
 */
export class TaskFormDataModel {
  /**Задача weeek */
  WeeekTask?: WeeekTaskModel;
  /**ID папки с файлами */
  FolderId?: string;
  /**Название */
  Name: string = '';
  /**Описание */
  Description?: string;
  /**Статус */
  StatusId!: number;
  /**Тип задачи */
  TypeId!: string;
  /**Приортите */
  PriorityId!: number;
  /**Уровень сложности */
  DifficultyId!: string;
  /**Исполнители */
  Performers: UserModel[] = [];
  /**Наблюдатели */
  Observers: UserModel[] = [];
  /**Исполнители */
  PerformerIds: Array<number> = [];
  /**Наблюдатели */
  ObserverIds: Array<number> = [];
  /**Оценка исполнителей */
  Estimated!: number;
  /**Дата дедлайна */
  DeadlineDate: Date = getDefaultDedlineDate();
  /**Список тегов */
  Tags: Array<number> = [];
  /**Список типов */
  Types: number[] = [];
  /**Подзадачи */
  SubtaskIds: Array<number> = [];
  /**Родительская задача */
  Parent?: TaskParentModel;
  /**Список файлов */
  Files: Array<TaskFileModel> = [];
  /**Список файлов на импорт */
  FilesToImport: Array<TaskImportFileModel> = [];
  /**Id копируемой задачи */
  CopyTaskId?: number;
  Owner?: UserTaskItem;

  constructor(obj?: Partial<TaskFormDataModel>) {
    Object.assign(this, obj);
  }
}
